import React, { useCallback, useContext, useState } from 'react';
import { Button } from '@mui/material';
import useStyles from './EditContactsButton.styles';
import EditContactsModal from './EditContactsModal';
import ContactsCountBadge from './ContactsCountBadge';
import { useSelectedLinkContext } from 'contexts';
import { shareContext } from '../../ShareContext';
import { EditContactsContextProvider } from './EditContactsContext';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import MobileEditContactsButton from 'mobile/App/Share/ExplorerToolbar/EditContacts/MobileEditContactsButton';
import {ShareFolderContacts} from 'components/icons';

type EditContactsButtonPureProps = {
  handleShowModal: () => void;
};

const EditContactsButtonPure = ({
  handleShowModal,
}: EditContactsButtonPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Button
        className={classes.button}
        data-testid="open-settings-modal-button"
        onClick={handleShowModal}
      >
        <ContactsCountBadge>
          <ShareFolderContacts fontSize='xlarge' />
        </ContactsCountBadge>
      </Button>

      <EditContactsModal />
    </>
  );
};

const EditContactsButton = (): JSX.Element | null => {
  const { selectedLink } = useSelectedLinkContext();
  const { selectedFolder } = useContext(shareContext);
  const isSmallScreen = useSmallDesktopScreen();

  const [contacts, setContacts] = React.useState<string[]>(
    selectedFolder?.sharedWith.map((_) => _.id) || [],
  );
  const isFolderAdmin = selectedFolder?.creator === selectedLink?.userKey;
  const [showEditContactsModal, setShowEditContactsModal] =
    useState<boolean>(false);

  const handleShowModal = useCallback(
    () => setShowEditContactsModal(true),
    [setShowEditContactsModal],
  );

  if (isFolderAdmin) {
    if (isSmallScreen) {
      return <MobileEditContactsButton />;
    } else {
      return (
        <EditContactsContextProvider
          contacts={contacts}
          showEditContactsModal={showEditContactsModal}
          setContacts={setContacts}
          setShowEditContactsModal={setShowEditContactsModal}
        >
          <EditContactsButtonPure handleShowModal={handleShowModal} />
        </EditContactsContextProvider>
      );
    }
  }

  return null;
};

export default EditContactsButton;
